import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgShareGhostLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M13.77 8.115a1 1 0 0 1-.448 1.342L9.26 11.488A1 1 0 0 1 8.365 9.7l4.063-2.031a1 1 0 0 1 1.341.447M7.917 12.96a1 1 0 0 1 1.342-.447l4.062 2.031a1 1 0 0 1-.894 1.789L8.365 14.3a1 1 0 0 1-.447-1.342'
      clipRule='evenodd'
      opacity={0.6}
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M12 7a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M2 12a4 4 0 1 1 8 0 4 4 0 0 1-8 0m4-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4M16 13a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-2 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgShareGhostLine)
export default ForwardRef
